import axios from "axios";

export const getLaporanDetailJurnalBukuBesarByKodeAkun = async (formData) => {
  return await axios.post(
    `${window._HOST}admin/laporanJurnal/detailBukuBesar`,
    formData,
    { withCredentials: true }
  );
};

export const getLaporanBukuBesar = async (formData) => {
  return await axios.post(
    `${window._HOST}admin/laporanJurnal/bukuBesar`,
    formData,
    { withCredentials: true }
  );
};
